import { For, Show } from 'solid-js';
import type { ScatterColorLegendItem } from '../../utils/scatterHistoryColorLegend';
import { scatterHistoryColorByDisplayName } from '../../utils/scatterHistoryColorLegend';

export interface ScatterHistoryColorLegendProps {
  colorType: string;
  items: ScatterColorLegendItem[];
  activeLabel?: string | null;
  activeLabels?: string[];
  onItemClick?: (label: string) => void;
}

export default function ScatterHistoryColorLegend(props: ScatterHistoryColorLegendProps) {
  return (
    <Show when={props.items.length > 0}>
      <div
        class="scatter-history-color-legend"
        role="list"
        aria-label={`Color by ${scatterHistoryColorByDisplayName(props.colorType)} legend`}
      >
        <span class="scatter-history-color-legend__title">
          Color by {scatterHistoryColorByDisplayName(props.colorType)}
        </span>
        <For each={props.items}>
          {(item) => {
            const isActive = () =>
              (props.activeLabels?.includes(item.label) ?? false) ||
              (props.activeLabel != null && props.activeLabel === item.label);
            return (
              <button
                type="button"
                class={`scatter-history-color-legend__item${isActive() ? ' scatter-history-color-legend__item--active' : ''}`}
                role="listitem"
                aria-pressed={isActive()}
                onClick={() => props.onItemClick?.(item.label)}
              >
                <span
                  class="scatter-history-color-legend__swatch"
                  style={{ 'background-color': item.color }}
                  aria-hidden="true"
                />
                <span class="scatter-history-color-legend__label">{item.label}</span>
              </button>
            );
          }}
        </For>
      </div>
    </Show>
  );
}
